module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Navi-Hype-Reel-Video.ac4f1b76.jpg";